import { useTranslation } from "react-i18next";
import { LANGUAGE_TYPES } from "@src/constants";
import { ReactComponent as LogoSVGEnglish } from "./logos/openUpLogoEnglish.svg";
import { ReactComponent as LogoSVGDutch } from "./logos/openUpLogoDutch.svg";
import { ReactComponent as LogoSVGGerman } from "./logos/openUpLogoGerman.svg";
import { ReactComponent as LogoSVGDefault } from "./logos/logotype.svg";

interface LogoProps {
  showLanguageSpecificIcon?: boolean;
}

const Logo: React.FC<LogoProps> = ({
  showLanguageSpecificIcon = false,
  ...props
}) => {
  const { i18n } = useTranslation();

  if (showLanguageSpecificIcon) {
    switch (i18n.language) {
      case LANGUAGE_TYPES.ENGLISH_US:
      case LANGUAGE_TYPES.FRENCH:
        return <LogoSVGEnglish {...props} />;
      case LANGUAGE_TYPES.DUTCH:
        return <LogoSVGDutch {...props} />;
      case LANGUAGE_TYPES.GERMAN:
        return <LogoSVGGerman {...props} />;

      default:
        return <LogoSVGDefault {...props} />;
    }
  }

  return <LogoSVGDefault {...props} />;
};

export default Logo;
